<template>
  <g x="0" y="0" :width="width" :height="height" class="not-copy">
    <GreenGrassOffice :width="width" :height="height" v-if="officeType.office === 0"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import GreenGrassOffice from '@/views/DashBoard/VirtualOffice/Landscape/GreenGrassOffice'
export default {
  name: 'Landscape',
  componentName: 'Landscape',
  props: ['width', 'height', 'officeType'],
  components: {
    GreenGrassOffice
  }
}
</script>

<style lang="scss" scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Landscape.vue